import { render, staticRenderFns } from "./LpPurchaseProductCreate.vue?vue&type=template&id=8f565db4&scoped=true"
import script from "./LpPurchaseProductCreate.vue?vue&type=script&lang=js"
export * from "./LpPurchaseProductCreate.vue?vue&type=script&lang=js"
import style0 from "./LpPurchaseProductCreate.vue?vue&type=style&index=0&id=8f565db4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f565db4",
  null
  
)

export default component.exports